<template>
  <div @mouseleave="handleMouseLeave">
    <v-chart ref="curChart" v-if="!change && chartData.length > 0" :forceFit="true" :height="140" :data="chartData" :scale="chart.scale" :padding="chart.padding" :onPlotLeave="handlePlotLeave">
      <v-series quickType="line" position="time*data" :shape="chartData.length === 1 ? 'line' : 'trendLine'" :tooltip="chart.tooltipMap" />
      <!-- 折线图绘制点 -->
      <v-series quickType="point" shape="circle" position="time*data" :tooltip="chart.tooltipMap" />    
      <v-axis :dataKey="chart.xAxis.key" :label="null" :tickLine="null" />
      <v-axis :dataKey="chart.yAxis.key" :label="chart.yAxis.label" />
      <v-tooltip />
    </v-chart>
  </div>
</template>

<script>
import Chart from '@/components/common/chart/chart.vue'
import { registerShape } from 'viser-vue';
import moment from "moment"
import { numberFormat } from '@/utils/utils';

// #region trendline 虚线
registerShape('line', 'trendLine', {
  draw(cfg, container) {
    const lineColor = '#1890FF';
    var path1 = [], path2 = [];
    for (var i = 0; i < cfg.points.length; i++) {
      if (i >= cfg.points.length - 2) {
        let pre = 'L';
        if (path2.length === 0) {
          pre = 'M'
        }
        path2.push([pre, cfg.points[i].x, cfg.points[i].y])
      }
      if (i <= cfg.points.length - 2) {
        let pre = 'L';
        if (path1.length === 0) {
          pre = 'M'
        }
        path1.push([pre, cfg.points[i].x, cfg.points[i].y])
      }
    }
    container.addShape('path', {
      attrs: {
        path: path1,
        stroke: lineColor,
        lineWidth: 2
      }
    });
    container.addShape('path', {
      attrs: {
        path: path2,
        stroke: lineColor,
        lineWidth: 2,
        lineDash: [5, 2],
        opacity: 0.7
      }
    });
    return container;
  }
})
// #endregion

export default {
  name: 'TrendChart',
  components: {
    Chart
  },
  props: ['isFirst', 'xList', 'yMax', 'cData', 'dateType'],
  data() {
    return {
      change: false,
    }
  },
  computed: {
    chart() {
      return {
        scale: [{
          dataKey: 'time',
          alias: "日期",
          type: 'cat',
          values: this.xList
        }, {
          dataKey: 'data',
          alias: "销量",
          min: 0,
          max: this.yMax
        }],
        tooltipMap: ["time*data", (t1, d1) => {
          const isWeek = this.dateType === 0;
          const title = isWeek ? `${t1} ~ ${moment(t1).add('days', 6).format("YYYY-MM-DD")}` : `${t1}`;
          return {
            title,
            name: '销量',
            value: d1
          }            
        }],
        xAxis: {
          key: 'time',
        },
        padding: this.isFirst ? [20, 0, 10, 50] : [20, 0, 10, 10],
        yAxis: {
          key: 'data',
          label: this.isFirst ? {
            autoRotate: true,
            formatter: (v) => {
              return numberFormat(v)
            }
          }: null,
          
        }
      }
    },
    chartData() {
      this.change = true
      this.$nextTick(()=>{
        this.change = false
      });
      return this.cData;
    }
  },
  methods: {
    handleMouseLeave() {
      this.$refs.curChart?.chart?.chartInstance?.hideTooltip();
    },
    handlePlotLeave(ev, chart) {
      chart.hideTooltip();
    },
  }
}
</script>

<style>

</style>